// import _authService from "../modules/authService";
// import { SESSION_TOKEN } from "../constants/constants";
import jwtDecode from "jwt-decode";
import setAuthToken from "../config/setAuthToken";
import { _assessment } from "../modules/_assessment";
import { _auth } from "../modules/_auth";
import { utils } from "../modules/_utils";
import { audit } from "../modules/_audit";
import { version } from "react";
import { SHOW_VENDOR_INTERCEPT } from "../constants/constants";

const createLoginSlice = (set) => ({
  status: "",
  isSuccess: false,
  isAuthenticated: false,
  isMfaSuccess: false,
  profile: {},
  error: "",
  loginError: false,
  loader: false,
  guestList: [],
  tenants: [],

  token: "",
  guestProfile: {},
  signupAsync: async (userData) => {
    const response = await _auth.signup(userData);
    console.log(response, "response");
    if (response.error.length === 0) {
      set(() => ({
        isSuccess: true,
        LoginUserData: response,
        errorMessage: "",
      }));
    } else {
      set(() => ({
        isSuccess: false,
        errorMessage: response.error,
      }));
    }
  },
  setTenantsId: async (id, profile, tenants) => {
    set(() => ({
      // selectedTenantId: id,
      profile: profile,
      tenants: tenants,
      tenantId: id,
    }));
  },
  getAuthAsync: async (history) => {
    let response = await _auth.getAuth(history);
    if (response && response.response && response.response.status === 401) {
      console.log("getAuthAsync !", response.response.status);
      _auth.removeUserToken("jwtToken");
      _auth.removeUserProfile("profile");

      set(() => ({
        status: "",
        isSuccess: false,
        isAuthenticated: false,
        // profile: {},
        error: "",
        loader: false,
        guestList: [],
        // tenants: [],
        // tenantId: "",
        // selectedTenantId: "",
        token: "",
        guestProfile: {},
      }));
      return false;
    } else {
      console.log("getAuthAsync ? ", response);
      return true;
    }
  },
  forgotPasswordAsync: async (u, history, strategy) => {
    try {
      let obj = {
        email: u,
      };
      console.log(obj, "obj");
      let response = await _auth.forgotPassword(obj);

      if (response) {
        sessionStorage.setItem("email", u);
        if (strategy === "LINK") {
          return true;
        } else {
          history.push("/reset-password");
          return true;
        }
        // Set token to ls
      } else {
        return false;
      }
    } catch (e) {
      set(() => ({
        loginError: true,
      }));
    }
  },
  resetPasswordAsync: async (otp, password, confirmpassword, history) => {
    try {
      let email = await sessionStorage.getItem("email");
      let data = {
        otp: otp,
        email: email,
        password: password,
        confirmpassword: confirmpassword,
      };
      let response = await _auth.resetPassword(data);
      if (response) {
        // Set token to ls
        history.push("/");
        return true;
      } else {
        return false;
      }
    } catch (e) {
      set(() => ({
        loginError: true,
      }));
    }
  },
  resetPasswordEmailAsync: async (
    id,
    token,
    password,
    confirmpassword,
    history
  ) => {
    let email = await sessionStorage.getItem("email");
    let data = {
      id: id,
      token: token,
      email: email,
      password: password,
      confirmpassword: confirmpassword,
    };
    let response = await _auth.resetPasswordEmail(data);
    if (response && response.data.status === 200) {
      // Set token to ls
      this.loader = false;
      history.push({
        path: "/",
      });
      return true;
    } else {
      return false;
    }
  },
  addUserAsync: async () => {},
  getAllUser: async (history) => {},
  loginAsync: async (userData, history) => {
    if (userData.email !== "") {
      ////debugger;
      const response = await _auth.login(userData);
      if (
        response &&
        response.data &&
        response.data.status &&
        response.data.status === 200
      ) {
        const { token } = response.data.data;
        // Set token to ls
        // utils.setLocalStorage("jwtToken", token);

        // userData.MFA === false && _auth.setUserToken(token);
        // Set token to Auth header
        // console.log("loginAsync Setting Auth Token setAuthToken");
        setAuthToken(token);

        // console.log("loginAsync Decoding token");
        const decoded = jwtDecode(token);
        // console.log("loginAsync Decoded token");
        if (decoded.MFA === true) {
          // console.log("loginAsync DO NOT SET TOKEN");
        } else {
          // console.log("loginAsync SET TOKEN", decoded);
          _auth.setUserToken(token);

          // console.log("User Token has been set");
        }
        // console.log("loginAsync removing guest profile");
        _auth.removeGuestProfile();
        // console.log("loginAsync Getting ready to set persist state");
        // debugger;
        set(() => ({
          isSuccess: true,
          // token: token,
          isAuthenticated: true,
          // profile: decoded,
          // tenants: decoded.tenants,

          error: "",
        }));
        // console.log("loginAsync Returning to signin page");
        // debugger;
        return { decoded, token };
      } else if (
        response &&
        response.response.status &&
        response.response.status === 400
      ) {
        ////debugger;
        //audit.logAction("Login Failed");
        set(() => ({
          isSuccess: false,
          isAuthenticated: false,
          error: response.response.data.errorMessage,
        }));
        return false;
        console.info("Returning disabled login");
      } else {
        // console.log("Returning failed login");
        //audit.logAction("Login Failed");
        set(() => ({
          isSuccess: false,
          isAuthenticated: false,
          error:
            "Login failed. Check your username and password, and be sure you've activated your account.",
        }));
        return false;
      }
    } else {
      set(() => ({
        isSuccess: false,
        isAuthenticated: false,
        error: "Please enter the details",
      }));
    }
  },

  mfa: async (otp, token, profile) => {
    let response = null;
    set(() => ({
      isSuccess: false,
    }));
    if (!otp) {
      set(() => ({
        isSuccess: false,
        isAuthenticated: false,
        error: "Please enter the correct OTP",
      }));
    } else {
      response = await _auth.MFA(otp, token);
      if (response) {
        // console.log("mfa response success", response);
        _auth.setUserToken(token);
        _auth.setUserProfile(profile, "mfa");
        set(() => ({
          isSuccess: true,
          isAuthenticated: true,
          isMfaSuccess: true,
          profile: profile,
          token: token,
        }));
      } else {
        // console.log("mfa response failure", response);
        set(() => ({
          isSuccess: false,
          isAuthenticated: false,
          isMfaSuccess: false,
          error: "Something went wrong",
        }));
      }
    }
    return response;
  },
  getGuestList: async () => {
    try {
      // //debugger;
      const response = await _assessment.getGuestList();
      //      debugger;
      if (response) {
        // debugger;
        // console.log(response);

        set(() => ({
          guestList: [...response],
        }));
      } else {
        set(() => ({
          guestList: [],
        }));
      }
    } catch (e) {
      set(() => ({
        error: "Something went wrong, Please try again in sometime",
      }));
    }
  },
  verifyGuestLogin: async (
    userId,
    token,
    name,
    email,
    tenantId,
    type,
    inviteId,
    assessment_name,
    history
  ) => {
    try {
      // debugger;
      let response = await _auth.verifyGuest(
        userId,
        token,
        name,
        email,
        inviteId
      );
      // debugger;
      if (response.data.status === 200) {
        //debugger;
        // console.log(response);
        _auth.setGuestProfile({
          userId,
          name,
          email,
          tenantId,
          type,
          inviteId,
          assessment_name,
          token,
        });

        set(() => ({
          guestProfile: {
            userId,
            name,
            email,
            tenantId,
            type,
            inviteId,
            assessment_name,
            token,
          },
        }));
        //debugger;
        let paramsState;
        if (type !== "pre") {
          paramsState = {
            isPreassessment: false,
            assessment_type: type,
            assessment_name: assessment_name,
            resume: false,
            // new_history_item: _assessment.getJsonTemplate(),
          };
        } else {
          paramsState = {
            isPreassessment: true,
            assessment_type: "pre",
            assessment_name: assessment_name,
            resume: false,
          };
        }
        //debugger;
        history.push({
          pathname: "/assessment",
          state: paramsState,
        });
        //debugger;
      } else {
        //debugger;
        // console.log(response);
      }
    } catch (err) {
      set(() => ({
        error: err,
      }));
    }
  },
  verifyVendorLogin: async (
    userId,
    token,
    name,
    email,
    company,
    tenantId,
    type,
    inviteId,
    assessment_name,
    history,
    solicitationId,
    vendorCompanyId,
    version,
    pricingVersion
  ) => {
    try {
      let response = await _auth.verifyGuest(
        userId,
        token,
        name,
        email,
        inviteId
      );

      if (response.data.status === 200) {
        //debugger;
        // console.log("Verify Vendor response", response);
        //delete profile from local storage
        _auth.removeUserProfile("profile");
        _auth.setGuestProfile({
          userId,
          name,
          email,
          tenantId,
          type,
          inviteId,
          assessment_name,
          token,
        });
        set(() => ({
          guestProfile: {
            userId,
            name,
            email,
            tenantId,
            type,
            inviteId,
            assessment_name,
            token,
            company,
            solicitationId,
            vendorCompanyId,
            version,
            pricingVersion,
          },
        }));
        //debugger;
        let paramsState;
        if (type !== "pre") {
          paramsState = {
            inviteId: inviteId,
            userId: userId,
            name: name,
            company: company,
            email: email,
            tenantId: tenantId,
            type: type,
            solicitationId: solicitationId,
            vendorCompanyId: vendorCompanyId,
            version: version,
            pricingVersion: pricingVersion,
          };
        } else {
          paramsState = {
            inviteId: inviteId,
            userId: userId,
            name: name,
            email: email,
            tenantId: tenantId,
            type: type,
            solicitationId: solicitationId,
            vendorCompanyId: vendorCompanyId,
            version: version,
            pricingVersion: pricingVersion,
          };
        }
        let detailsProfile = JSON.parse(_auth.getGuestProfile());
        let details = {
          ...paramsState,
        };
        audit.logAction("View Bid Request Details", details);
        let pathname;
        // debugger;
        if (version && version == "v2") {
          pathname = "/projects/project-details/vendor-bid-info-v2";
          if (SHOW_VENDOR_INTERCEPT) {
            pathname = "/vendor-intercept";
          } else {
            // console.log("process.env", process.env);
          }

          // console.log("Navigating to Version 2", pathname);
          // pathname = "/projects/project-details/vendor-bid-info-v2";
          // debugger;
          history.push({
            pathname: pathname,
            state: paramsState,
          });
        } else {
          console.log("Version 1");
          pathname = "/projects/project-details/vendor-bid-info";
          history.push({
            pathname: pathname,
            state: paramsState,
          });
        }

        //debugger;
      } else {
        //debugger;
        console.log(response);
      }
    } catch (err) {
      set(() => ({
        error: err,
      }));
    }
  },
  logout: () => {
    set(() => ({
      isSuccess: false,
      token: null,
      LoginUserData: null,
      selectedTenantId: "",
      tenantId: "",
      profile: {},
      guestProfile: {},
      loginError: "",
      error: "",
    }));
    //sessionStorage[SESSION_TOKEN] = "";
    // _authService.logout();
  },
});

export default createLoginSlice;
